import { useState } from 'react';
import GuestIcon from '../../assets/images/guest.png';

import { guestAPI } from '../../api/guestAPI';

export default function GuestSeach({ setCusCode, setCusName }) {

    const [inputKey, setInputKey] = useState('');
    const [guest, setGuest] = useState([]);

    const onChangeInputKey = (key) => {
        setInputKey(key);

        guestAPI.searchGuest(key).then((data) => setGuest(data));
    }

    const onSelectGuest = (cusCode, cusName) => {
        setCusCode(cusCode);
        setCusName(cusName);

        document.getElementById("modalGuestSearch_close").click();
    }

    return (
        <>
            <button className="btn btn-primary form-control" data-bs-toggle="modal" data-bs-target="#modalGuestSearch">
                Guest <span className="d-none d-lg-inline d-xl-inline d-xxl-inline">Search</span>
                <img src={GuestIcon} alt="" className="ms-1" />
            </button>

            <div id="modalGuestSearch" className="modal fade" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title text-danger text-center">Search Guest</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    Search
                                    <input type="text" className="form-control" value={inputKey}
                                        onInput={(e) => onChangeInputKey(e.target.value)} maxLength="50"
                                        placeholder="Search by guest code / name" />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                                    <table className="table table-sm table-hover">
                                        <thead className="thead--color">
                                            <tr>
                                                <td>Code</td>
                                                <td>Guest Name</td>
                                                <td className="text-center">Action</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                guest.map((data, index) => (
                                                    <tr key={index}>
                                                        <td>{data.cusCode}</td>
                                                        <td>{data.cusName}</td>
                                                        <td className="text-center">
                                                            <button type="button" className="btn btn-sm btn-primary"
                                                                onClick={() => onSelectGuest(data.cusCode, data.cusName)}                                                          >
                                                                Select
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="row mt-1">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 px-12">
                                    <button className="btn btn-secondary form-control mt-1" data-bs-dismiss="modal"
                                        id="modalGuestSearch_close">
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}